import { createPropertySelectors, createSelector } from '@ngxs/store';

import {
  CustomerPortalCollectionAuthState,
  type CustomerPortalCollectionAuthStateModel,
} from '../states';

/**
 * `@__PURE__` IIFE — tree-shakable by esbuild/Rollup/Webpack when unused.
 *
 * Avoid namespace — compiles to a var + IIFE pattern that bundlers treat
 * as a side effect, preventing tree-shaking regardless of `@__PURE__`.
 */
export const CustomerPortalCollectionAuthQueries = /*@__PURE__*/ (() => {
  const { session: getSession, accessCode: getAccessCode } =
    createPropertySelectors<CustomerPortalCollectionAuthStateModel>(
      CustomerPortalCollectionAuthState
    );

  const getToken = createSelector(
    [getSession],
    (session) => session?.access_token
  );

  return { getSession, getAccessCode, getToken };
})();
